import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ShamHome02Icon } from 'sham-components/icons';

@Component({
  selector: 'app-payment-status-banner',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule, ShamHome02Icon],
  templateUrl: './payment-status-banner.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentStatusBanner {
  readonly imageSrc = input.required<string>();
  readonly message = input.required<string>();
  readonly title = input.required<string>();
  readonly buttonText = input<string>('');
  readonly buttonLink = input<string | readonly string[] | null>(null);
  readonly secondaryButtonText = input<string>('');
  readonly secondaryButtonLink = input<string | readonly string[] | null>(null);
  readonly primaryAction = output<Event>();
  readonly secondaryAction = output<Event>();
}
